import React, { Fragment } from 'react'
import { TextField } from '@mui/material'

import { getLog } from '../../helpers/helpers.js'
import { UserContext } from "../../Contexts/UserContext/UserContext.js"
import ClickToOpenCardDark from '../../components/ClickToOpenCardDark.js'
import { Row } from "../../components/Row"
import { Loader } from '../../components/Loader.js'
import ButtonParam from './ButtonParam.js'


/**
 * Load a Token section — enter a token address and load it into the wallet.
 *
 * Props:
 *   - run: the Run instance (or null while loading)
 */
class SectionLoadToken extends React.Component {

	static contextType = UserContext

	constructor(props) {
		super(props)
		this.classname = "Slide_Settings/SectionLoadToken: "

		this.state = {
			tokenorigin: "",
		}

		this.handleChangeTokenOrigin = this.handleChangeTokenOrigin.bind(this)
		this.clickedUpdateTokenOrigin = this.clickedUpdateTokenOrigin.bind(this)
	}

	componentDidMount() {
		this.setState({ tokenorigin: this.context.tokenorigin })
	}

	handleChangeTokenOrigin(event) {
		if (!this.props.run) {
			window.alert("wait for wallet to have fully loaded before doing this action")
			return
		}
		this.setState({ tokenorigin: event.target.value })
	}

	clickedUpdateTokenOrigin(event) {
		event.preventDefault()
		if (!this.props.run) {
			window.alert("wait for wallet to have fully loaded before doing this action")
			return
		}
		window.alert(
			"Cliquez OK pour charger le nouveau contrat, "
			+ "attention cette opération peut prendre plusieurs minutes:"
		)
		this.context.update_contract_origin_and_reload(this.state.tokenorigin)
	}

	render() {
		const run = this.props.run
		const buttonsCustomStyle = {
			cursor: run ? "pointer" : "not-allowed",
			backgroundColor: run ? "" : "grey",
			pointerEvents: run ? "auto" : "none"
		}

		return (
			<Fragment>
				<ClickToOpenCardDark title="Load a Token">
					<center><br />
						<Row>
							<TextField fullWidth
								id="outlined-basic" variant="outlined"
								label={<span>Address of a token</span>}
								value={this.state.tokenorigin ? this.state.tokenorigin : ""}
								onChange={this.handleChangeTokenOrigin}
								placeholder={""}
							/>
						</Row><br />

						<Row>
							{this.context.tokens_balance[this.context.get_selected_coin_props().tokenid] != null ?
								<ButtonParam
									onClick={run ? this.clickedUpdateTokenOrigin : null}
									style={buttonsCustomStyle}
								>
									{run ? "Charger ce token" : "Chargement..."} {run ? null : <Loader small black />}
								</ButtonParam>
								:
								<ButtonParam onClick={this.clickedUpdateTokenOrigin} style={{
									cursor: "pointer", backgroundColor: "grey", pointerEvents: "none",
								}}>
									loading... <Loader small black />
								</ButtonParam>
							}
						</Row>
						<br /><br />

						<span style={{ wordBreak: "break-all" }}>
							<center>
								<div style={{ color: "silver" }}>
									<i style={{ fontSize: "22px", marginRight: "10px" }} className="fa fa-info-circle" /><br />
									Delphe: f597770adc303efe702fcc1497b87703d166adc9d2a5a4cd8e92c571b2324201_o1<br />
								</div>
							</center>
						</span>
					</center>
				</ClickToOpenCardDark>
				<br />
			</Fragment>
		)
	}
}

export default SectionLoadToken
